/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;

	export class Route extends View<THREE.Object3D> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(terrain:Terrain) {
			super(new THREE.Object3D());
			this.terrain = terrain;
			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():THREE.Object3D {
			const view:THREE.Object3D = this.getView();

			const assetLoader:AssetLoader = AssetLoader.getInstance();
			this.track = assetLoader.getTrack();
			this.zoomLevel = assetLoader.getMeta().getZoomLevel();

			this.information = Information.getInstance();

			this.trackPoints = [];
			const trackPoints:TrackPoint[] = this.track.getPoints();
			const trackPointCount:number = trackPoints.length;
			for (let i:number = 0; i < trackPointCount; ++i) {
				const trackPoint = trackPoints[i];
				trackPoint.getPosition().calcPixelCoord(this.zoomLevel);
				this.trackPoints.push(trackPoint);
			}

			this.pointCountCurrent = 0;
			this.pointCountTotal = this.trackPoints.length;
			trace('[Route] pointCountTotal :', this.pointCountTotal);

			// head
			//this.headIndex = -1;
			this.headPosition = new THREE.Vector3();
			this.headTrackPoint = null;
			//this.nextTrackPoint = this.pointCountTotal > 0 ? this.trackPoints[0] : null;

			this.head = new RouteHead();
			view.add(this.head.getView());

			// line
			this.line = new RouteLine(this.track, this.zoomLevel, this.terrain);
			view.add(this.line.getView());

			// pin
			this.threeManager = ThreeManager.getInstance();

			this.startScreenPosition = new THREE.Vector3();
			this.startPosition = this.getTrackSpacePosition(this.trackPoints[0]);
			this.startEdge = new RouteEdge(true, this.startPosition);
			view.add(this.startEdge.getView());
			//this.startPin = jQuery('#start-point');

			this.goalScreenPosition = new THREE.Vector3();
			this.goalPosition = this.getTrackSpacePosition(this.trackPoints[trackPointCount - 1]);
			this.goalEdge = new RouteEdge(false, this.goalPosition);
			view.add(this.goalEdge.getView());
			//this.goalPin = jQuery('#goal-point');

			return view;
		}

		protected implReady():void {
			this.head.ready();
			this.line.ready();
			this.startEdge.ready();
			this.goalEdge.ready();
		}

		protected implFinalize():void {
			this.head.finalize();
			this.line.finalize();
			this.startEdge.finalize();
			this.goalEdge.finalize();

			this.information = null;
		}

		protected implShow(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				this.head.show(useTransition);
				this.line.show(useTransition);
			});
		}

		protected implHide(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				this.head.hide(useTransition);
				this.line.hide(useTransition);
			});
		}

		public update():void {
			if (!this.getIsShown()) return;

			this.head.updatePosition(this.headPosition);

			this.startEdge.update();
			//this.threeManager.project(this.startPosition, this.startScreenPosition);
			//this.startPin.css({
			//	left: this.startScreenPosition.x,
			//	top: this.startScreenPosition.y,
			//	display: this.startScreenPosition.z > 1 ? 'none' : 'block',
			//});

			this.goalEdge.update();
			//this.threeManager.project(this.goalPosition, this.goalScreenPosition);
			//this.goalPin.css({
			//	left: this.goalScreenPosition.x,
			//	top: this.goalScreenPosition.y,
			//	display: this.goalScreenPosition.z > 1 ? 'none' : 'block',
			//});

			// stats
			this.information.setCurrentMarkerPosition(this.headPosition);
		}

		//private checkTimeOver(trackPoint:TrackPoint, time:number):boolean {
		//	let trackPointTime:number = trackPoint.getDateTime();
		//	return time >= trackPointTime;
		//}

		/*
		private addPoint(time:number):void {
			if (this.pointCountCurrent == this.pointCountTotal) return;

			while (true) {
				if (!this.checkTimeOver(this.nextTrackPoint, time)) break;

				++this.headIndex;
				++this.pointCountCurrent;

				this.setHeadPosition(this.headIndex);

				if (this.pointCountCurrent == this.pointCountTotal) {
					this.nextTrackPoint = null;
					break;
				} else {
					this.nextTrackPoint = this.trackPoints[this.headIndex + 1];
				}
			}
		}
		*/

		/*
		private setHeadPosition(point:TrackPoint):void {
			this.headTrackPoint = point;

			const position:THREE.Vector3 = this.getTrackSpacePosition(this.headTrackPoint);
			this.headPosition.set(position.x, position.y, position.z);

			this.information.setCurrentDistance(this.headTrackPoint.getDistance());
			this.information.setCurrentElevation(this.headTrackPoint.getElevation());
		}
		*/

		public showEdge(useTransition:boolean = true):void {
			//this.startPin.css('display', 'block');
			//this.goalPin.css('display', 'block');

			this.startEdge.show(useTransition);
			this.goalEdge.show(useTransition);
		}

		public hideEdge(useTransition:boolean = true):void {
			//this.startPin.css('display', 'none');
			//this.goalPin.css('display', 'none');

			this.startEdge.hide(useTransition);
			this.goalEdge.hide(useTransition);
		}

		public setHeadPosition(point:LeapedTrackPoint):void {
			this.headTrackPoint = point;

			const position:THREE.Vector3 = this.getLeapedTrackSpacePosition(this.headTrackPoint);
			this.headPosition.set(position.x, position.y, position.z);

			this.information.setCurrentDistance(this.headTrackPoint.getDistance());
			this.information.setCurrentElevation(this.headTrackPoint.getElevation());
		}

		//private getTrackSpacePosition(trackPoint:TrackPoint):THREE.Vector3 {
		//	return Unit.pixelElevationToSpace(trackPoint.getPosition().getPixel(), trackPoint.getElevation(), this.zoomLevel);
		//}

		private getTrackSpacePosition(trackPoint:TrackPoint):THREE.Vector3 {
			return Unit.pixelElevationToSpace(trackPoint.getPosition().getPixel(), trackPoint.getElevation(), this.zoomLevel);
		}

		private getLeapedTrackSpacePosition(point:LeapedTrackPoint):THREE.Vector3 {
			return Unit.pixelElevationToSpace(point.getPixelPosition(), point.getElevation(), this.zoomLevel);
		}

		public getHeadPosition():THREE.Vector3 {
			return this.headPosition;
		}

		//public getHeadTrackPoint():TrackPoint {
		//	return this.headTrackPoint;
		//}

		public getHeadObject():THREE.Object3D {
			return this.head.getView();
		}

		public getTrack():Track {
			return this.track;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private terrain:Terrain;
		private zoomLevel:number;

		private track:Track;
		private trackPoints:TrackPoint[];
		private headTrackPoint:LeapedTrackPoint;

		private line:RouteLine;
		private pointCountTotal:number;
		private pointCountCurrent:number;

		//private nextTrackPoint:TrackPoint;
		//private headIndex:number;
		//private headTrackPoint:TrackPoint;

		private information:Information;

		private head:RouteHead;
		private headPosition:THREE.Vector3;

		private startPosition:THREE.Vector3;
		private startScreenPosition:THREE.Vector3;
		private startEdge:RouteEdge;
		//private startPin:JQuery;

		private goalPosition:THREE.Vector3;
		private goalScreenPosition:THREE.Vector3;
		private goalEdge:RouteEdge;
		//private goalPin:JQuery;

		private threeManager:ThreeManager;
	}
}
